
<div :key = "refresh">
    <a @click = "onExpand" >
        <div class="v-flex">
            <div
                class = "location-address"
                :class = "!contact ? 'error--text' : ''"
                @click.stop = "onLocate"
                style = "cursor: pointer;"
            >
                {{ location.zip }} {{ location.city }}, {{ location.street }}
            </div>

            <v-spacer />

            <div v-if = "location.expanded && location.units.length > 1">
                <p-assign-buttons
                    v-if          = "assignOn"
                    :plus-active  = "true"
                    :minus-active = "true"
                    :units        = "location.units"
                    @plus         = "onAssignAll"
                    @minus        = "onDissolveAll"
                />

                <p-dispatch-buttons
                    v-if          = "dispatchOn"
                    :user         = "user"
                    :plus-active  = "true"
                    :minus-active = "true"
                    :units        = "location.units"
                    @plus         = "onDispatchAll"
                    @minus        = "onReleaseAll"
                />
            </div>

            <div class = "location-counter">
                {{ assignedUnitsCount }} / {{ totalUnitsCount }}
            </div>
        </div>

        <div class = "location-contact">
            {{ contact ? contact : $t("disposition.inspection.contact.na") }}
        </div>
    </a>
</div>
